import Vue from 'vue'
import Router from 'vue-router'
import mainRoutes from './mainRoutes'
import routesConf from './routesConf'
// import routeHelper from '../utils/routeHelper'
import store from '@core/store/'
import { Message } from 'element-ui'
Vue.use(Router)
// const ladyLoading = url => () => import(`@src/area-contract/views/${url}.vue`)

// 租控管理
// const Home = ladyLoading('Home/home')
// const resulstRoute = routeHelper.tilingRoute(routesConf)
const resulstRoute = routesConf
// const resulstRoute = routesConf
mainRoutes[0].children = resulstRoute
// mainRoutes[0].children.unshift(
//   {
//     path: '/home',
//     name: 'home',
//     component: Home,
//     children: [],
//     meta: {
//       hideInAdmin: false,
//       menuId: 'contract004',
//       type: 'menu',
//       zhname: '首页',
//       icon: 'rentcontrolfirstpage'
//     }
//   }
// )

const router = new Router({
  routes: mainRoutes
})

const hasPermission = (route) => {
  return true
}

router.beforeEach((to, from, next) => {
  const tabList = store.getters.tabList
  if (tabList.length >= 10 && tabList.findIndex(tab => tab.fullPath === to.fullPath) === -1) {
    Message.warning('页面数量超过限制，请关闭部分页签')
    return
  }
  if (hasPermission(to)) {
    next()
  } else {
    next('/')
  }
})

export default router



// WEBPACK FOOTER //
// ./src/area-core/router/index.js